import { React } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Plans from "./pages/Plans";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import "./styles.css";
import Expert from "./pages/Expert";
import FreeBet from "./pages/FreeBet";
import Premium from "./pages/Premium";
import Rollover from "./pages/Rollover";
import Faqs from "./pages/Faqs";
import TermsAndConditions from "./pages/TermsAndConditions";
import axios from "axios";
import { Toaster } from "react-hot-toast";
import { UserContextProvider } from "./context/UserContext";

axios.defaults.baseURL = "/api";
axios.defaults.withCredentials = true;

export default function App() {
  return (
    <UserContextProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ duration: 3000 }} />
        {/* <Header /> */}
        <Routes>
          <Route index element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/predictions/expert" element={<Expert />} />
          <Route path="/predictions/freebet" element={<FreeBet />} />
          <Route path="/predictions/premium" element={<Premium />} />
          <Route path="/predictions/rollover" element={<Rollover />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </BrowserRouter>
    </UserContextProvider>
  );
}
